//#region src/theme/borders.ts
const borders = {
	none: 0,
	default: `1px solid var(--colors-neutral-300)`,
	secondary: `1px solid var(--colors-neutral-500)`,
	dashed: `1px dashed var(--colors-neutral-500)`
};
var borders_default = borders;

//#endregion
export { borders_default as default };
//# sourceMappingURL=borders.js.map